import styles from '../../AdminTools.module.css'

export interface HeaderAlignedTaBortButtonProps {
  handleClick: () => void
  disabled?: boolean
  buttonText?: string
}

export const HeaderAlignedTaBortButton = ({
  handleClick,
  disabled = false,
  buttonText = 'Ta bort',
}: HeaderAlignedTaBortButtonProps) => {
  return (
    <div className={styles.headerAlignedButton}>
      <button
        className={styles.kontrollButton}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonText}
      </button>
    </div>
  )
}
